import { currentRefinements } from 'instantsearch.js/es/widgets'

export const catalogCurrentRefinements = currentRefinements({
  container: "[data-widget='catalogCurrentRefinements']",
})
